/**
 * Copyright © 2014 Goodgame Studios. All rights reserved.
 *
 * Created with IntelliJ IDEA
 * Creator: pburst
 * Created: 10.07.2014, 19:11
 *
 * $URL: $
 * $Rev: $
 * $Author: $
 * $Date: $
 * $Id: $
 */

import { BasicConstants } from "../../constants/BasicConstants";
import { LiveEnvironment } from "./LiveEnvironment";

/**
 * Represents the live or production environment of the client
 */
export class TestEnvironment extends LiveEnvironment {
    public static TEST_ENVIRONMENT_ID: string = "TestEnvironment";

    constructor(id?: string) {
        super(id !== undefined ? id : TestEnvironment.TEST_ENVIRONMENT_ID);
    }

    public initPatterns(): void {
        super.initPatterns();
        if (!this._data.globals.urlVariables.forceToShowTestServers) {
            this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-netconf-test/{gameId}/{networkId}.xml";
        }


        this._networkConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/network/{gameId}/html5/1.xml";//TODO @HTML5 HTML-961 HTML-925 set proper path

        this._countryConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/country/{gameId}/{countryVersion}/country.xml";
        this._languageConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/language/{gameId}/{languageVersion}/{languageCode}.{zipSuffix}";
        this._cldrConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + ":///files.{domain}/games-config-test/language/{gameId}/cldr";
        this._accountCookiePathPattern = BasicConstants.DOMAIN_PROTOCOL + "://account.{domain}/CookieSaver.swf";

        this._versionPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/games-config-test/version/{gameId}/version.json"; //TODO @HTML5 HTML-961 HTML-925 set proper path

        this._branchesConfigPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-test/{gameFileName}/branches.xml";
        this._gameUrlPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/branches-test/{gameFileName}/{branchId}/{gameTitle}Game_{branchVersion}.swf";

        this._refCountURLPattern = BasicConstants.DOMAIN_PROTOCOL + "://files.{domain}/loader-test/refcount.php";

        this._shopPathPattern = BasicConstants.DOMAIN_PROTOCOL + "://shop-test.goodgamestudios.com/{languageCode}/";
    }

    public isSupported(): boolean {
        return this._data.globals.isTest;
    }
}
